/**
 * Creates a virtual download link to trigger a manual file download.
 *
 * @param {String} fileName - The to be cloned value.
 * @param {String} fileUrl - The to be cloned value.
 */
export default function downloadFileByUrl(fileName, fileUrl) {
  const virtualLink = document.createElement('a');

  virtualLink.setAttribute('download', fileName);
  virtualLink.href = fileUrl;

  document.body.append(virtualLink);

  virtualLink.click();
  virtualLink.remove();
}
